import { createError, defineNuxtRouteMiddleware } from '#imports'
import type { RouteParamsGeneric } from 'vue-router'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { isTestEnv } from '@backmarket/utils/env/isTestEnv'

/**
 * Accepts only alphanumeric characters and hyphens
 */
const validParamRegex = /^[a-zA-Z0-9-]+$/

function checkPathParams(
  pathParams: RouteParamsGeneric,
):
  | { invalid: true; invalidParam: string; invalidParamValue: string }
  | { invalid: false } {
  if (!validParamRegex.test(String(pathParams.pageName))) {
    return {
      invalid: true,
      invalidParam: 'pageName',
      invalidParamValue: String(pathParams.pageName),
    }
  }

  if (
    pathParams.pageCategory &&
    !validParamRegex.test(String(pathParams.pageCategory))
  ) {
    return {
      invalid: true,
      invalidParam: 'pageCategory',
      invalidParamValue: String(pathParams.pageCategory),
    }
  }

  return { invalid: false }
}

export const catchInvalidCMSParams = defineNuxtRouteMiddleware((to) => {
  if (import.meta.client && !isTestEnv()) return

  const result = checkPathParams(to.params)
  const logger = useLogger()

  if (result.invalid) {
    const errorMessage = `[CMS] Invalid page params: ${result.invalidParam} "${result.invalidParamValue}"`
    logger.error(errorMessage, {
      owners: ['bot-squad-content-front'],
      invalidParam: result.invalidParam,
      invalidParamValue: result.invalidParamValue,
    })
    throw createError({
      statusCode: 404,
      statusMessage: errorMessage,
      fatal: true,
    })
  }
})
